'use strict';

angular.module('governanceProcessModule', [
]);